import { useEffect } from 'react';

/**
 * Casa de Candy — Apple-style scroll reveal.
 *
 * Picks up every element with [data-reveal] and toggles `is-revealed`
 * the first time it enters the viewport. Idempotent and respects
 * prefers-reduced-motion via the CSS layer.
 */
export function useScrollReveal(deps = []) {
  useEffect(() => {
    const elements = document.querySelectorAll(
      '[data-reveal]:not(.is-revealed), .casa-legal .legal-section:not(.is-revealed)'
    );
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useScrollReveal;
